import React, { useEffect, useState } from 'react';
import ListTables from '../../components/shared/tables';
import Base from '../base';
import { Alert, Row, Col } from '@themesberg/react-bootstrap';
import { get } from '../../services/back.service';
import DirectionPathButton from '../../components/widgets/directionPathButton';

function ListSchedule() {
  const [msgGet ,setMsgGet] = useState('');
  const [schedules,setSchedule] = useState([]);
  const [alert, setAlert] = useState({
    show: false,
    message: '',
    type: ''
  });
  useEffect(() => {
    getSchedule()
  }, []);

  const editButton = (row) => {
    const cPath = '/schedules/schedule/'+row.id;
    return (
      <Row>
        <Col>
          <DirectionPathButton  path={cPath} variant="outline-primary" text="Editar" />
        </Col>
      </Row>
    );
  };

  const getSchedule = async()=>{
    const responseSchedule = await get('/schedule/',{})
    if(responseSchedule.success){
      setSchedule(responseSchedule.data);
    }else{
      setMsgGet(responseSchedule.message)
    }       
  }


  return (
    <Base>
      {alert.show && <Alert variant={alert.type} onClose={() => setAlert({show: false})} dismissible>{alert.message}</Alert>}

      <DirectionPathButton text="Crear Agenda"  path="/schedules/schedule/0" variant="primary"  />

      <ListTables
        data={schedules}
        editar={editButton}
        messageWd={msgGet}
      />
    </Base>
  );
}

export default ListSchedule;
